import { FC } from 'react';
import styles from './DeliveryLeftItem.module.css';
import type { DeliveryLeftItemProps } from './DeliveryLeftItem.types';
import { Text } from '@/_components/Text/Text';
import { Flex } from '@/_components/Flex/Flex';

export const DeliveryLeftItem: FC<DeliveryLeftItemProps> = ({
  color,
  title,
  onClick,
  isActive,
}) => {
  return (
    <Flex
      className={`${styles.deliveryLeftItem} ${isActive ? styles.active : ''}`}
      onClick={onClick}
      style={{
        backgroundColor: isActive ? 'var(--bg-primary-hover)' : undefined,
      }}
    >
      {color && (
        <div
          className={styles.colorIndicator}
          style={{ backgroundColor: color }}
        />
      )}
      <Text type="small">{title}</Text>
    </Flex>
  );
};
